<template lang="pug">
    div.cloud(:style="opacityIntensivity")
        img(:src="cloudImage" alt="Cloud")
</template>

<script>
    import VueTypes from 'vue-types';
    import cloudImage from './clouds.png';

    export default {
        props: {
            mood: VueTypes.number.def(0)
        },
        data() {
            return {
                cloudImage
            };
        },
        computed: {
            /**
             * Change css opacity if mood prop changed.
             * @returns {{opacity: string}}
             */
            opacityIntensivity() {
                return {
                    opacity: `${1 - this.mood * 0.02}`
                };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .cloud
        position: absolute
        top: 0
        left: 0
        overflow: hidden
        width: 100%
        height: 100%

    img
        width: 100%
</style>
